import axios from 'axios'

const http = axios.create({
    // baseURL: '/api', //本地
    baseURL: 'https://admin.mascot-cn.com', //线上
    timeout: 1000,
    header: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
});
//请求拦截
http.interceptors.request.use(config => {
    config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
    return config
}, err => {
    console.log(err);
})
//响应拦截
http.interceptors.response.use(res => {
    if(res.data.code === 0 || res.data.code === 1) {
        return res.data;
    } else if (res.data.code === 2) {
        console.log(res.data.msg)
        return false;
    } else if (res.data.code === 1003) {
        console.log(res.data.msg)
        return false;
    } else return false;
}, (res) => {
    console.log(res)
    return false;
})

export default http;



// WEBPACK FOOTER //
// ./src/axios/baseURL.js